import axios from 'axios'
import { useAuthStore } from '@/stores/auth'
import router from '@/router'
import { message } from 'ant-design-vue'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:8000/api/v1',
  timeout: 30000
})

// Token expiration warning tracker
let tokenWarningShown = false

// Request interceptor
instance.interceptors.request.use(
  config => {
    const authStore = useAuthStore()
    if (authStore.token) {
      config.headers.Authorization = `Bearer ${authStore.token}`
      
      // Check token expiration and warn user
      if (authStore.tokenExpiresAt) {
        const now = Date.now()
        const expiresAt = authStore.tokenExpiresAt
        const timeLeft = expiresAt - now
        const minutes = Math.floor(timeLeft / 60000)
        
        // Warn 5 minutes before expiration
        if (minutes <= 5 && minutes > 0 && !tokenWarningShown) {
          tokenWarningShown = true
          message.warning(`Oturumunuz ${minutes} dakika sonra sona erecek. Lütfen sayfayı yenileyin.`, 10)
        }
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Response interceptor
instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      const authStore = useAuthStore()
      authStore.logout()
      router.push({ name: 'Login' })
    }
    return Promise.reject(error)
  }
)

export default instance

